const chinhSachBaoMat = () => {
  return (
    <div className="container chinh-sach mt-6">
      <div className="chinh-sach-bao-mat list-chinhsach px-4">
        <h4 className="text-center text-uppercase">Chính sách bảo mật</h4>
        <blockquote className="mb-3">
          <p>1. Mục đích và phạm vi thu nhập</p>
        </blockquote>
        <p className="mb-2">
          Chúng tôi sẽ thu thập nhiều thông tin khác nhau của quý khách khi bạn
          muốn đặt hàng trên web. Quý khách có thể sẽ được yêu cầu đăng ký thông
          tin cá nhân (Email, Họ tên, Sđt liên lạc, địa chỉ giao hàng, địa chỉ
          email). Mọi thông tin khai báo phải đảm bảo tính chính xác và hợp
          pháp. Giga Digital không chịu mọi trách nhiệm liên quan đến pháp luật
          của thông tin khai báo.{" "}
        </p>
        <p className="mb-2">
          Chúng tôi có thể chuyển tên và địa chỉ cho bên thứ ba để họ giao hàng
          cho bạn (ví dụ cho bên chuyển phát nhanh hoặc nhà cung cấp).
        </p>
        <p>
          Chi tiết đơn đặt hàng của bạn được chúng tôi lưu giữ nhưng vì lí do
          bảo mật nên chúng tôi không công khai trực tiếp được. Tuy nhiên, quý
          khách có thể tiếp cận thông tin bằng cách đăng nhập tài khoản trên
          web. Tại đây, bạn sẽ thấy chi tiết đơn đặt hàng của mình, những sản
          phẩm đã nhận và những sản phẩm đã gửi và chi tiết email, ngân hàng và
          bản tin mà bạn đặt theo dõi dài hạn. Quý khách cam kết bảo mật dữ liệu
          cá nhân và không được phép tiết lộ cho bên thứ ba. Chúng tôi không
          chịu bất kỳ trách nhiệm nào cho việc dùng sai mật khẩu nếu đây không
          phải lỗi của chúng tôi.
        </p>
        <br />

        <blockquote className="mb-3">
          <p>2. Phạm vi sử dụng thông tin</p>
        </blockquote>
        <p>
          Giga Digital thu thập và sử dụng thông tin cá nhân của khách hàng với
          mục đích phù hợp và hoàn toàn tuân thủ nội dung của “Chính sách bảo
          mật” này, cụ thể như sau:{" "}
        </p>
        <p className="mb-3"></p>
        <p>
          Khi cần thiết, chúng tôi có thể sử dụng những thông tin này vào các
          mục đích:
        </p>
        <br />
        <ul className="list-unstyled">
          <li>
            - Xử lý đơn hàng: gọi điện, gửi email hoặc tin nhắn xác nhận việc
            đặt hàng, thông báo về trạng thái đơn hàng & thời gian giao hàng,
            xác nhận việc huỷ đơn hàng (nếu có).
          </li>
          <li>
            - Gửi thư ngỏ/thư cảm ơn, giới thiệu sản phẩm mới, dịch vụ mới hoặc
            các chương trình khuyến mãi của Giga Digital.
          </li>
          <li>- Gửi thông tin về bảo hành sản phẩm</li>
          <li>- Giải quyết khiếu nại của khách hàng</li>
          <li>- Thông tin trao thưởng (của Giga Digital hoặc của hãng)</li>
          <li>- Các khảo sát để chăm sóc khách hàng tốt hơn</li>
          <li>
            - Xác nhận các thông tin về kỹ thuật & bảo mật thông tin khách hàng
          </li>
          <li>
            - Các trường hợp có sự yêu cầu của cơ quan nhà nước có thẩm quyền,
            theo đúng quy định của pháp luật
          </li>
        </ul>
        <br />

        <blockquote className="mb-3">
          <p>3. Thời gian lưu trữ thông tin</p>
        </blockquote>
        <p>
          {" "}
          Dữ liệu cá nhân của khách hàng sẽ được lưu trữ cho đến khi có yêu cầu
          hủy bỏ hoặc tự quý khách đăng nhập và thực hiện hủy bỏ. Còn lại trong
          mọi trường hợp thông tin cá nhân thành viên sẽ được bảo mật trên máy
          chủ của Giga Digital.
        </p>
        <br />

        <blockquote className="mb-3">
          <p>4. Địa chỉ của đơn vị thu thập và quản lý thông tin cá nhân</p>
        </blockquote>
        <p className="mb-2">
          Tên tổ chức:{" "}
          <strong className="text-uppercase">
            {" "}
            CÔNG TY CỔ PHẦN CÔNG NGHỆ HỢP LONG
          </strong>
        </p>
        <p className="mb-2">
          Văn phòng:
          <span>
            {" "}
            Tầng 3, Sảnh A Tòa nhà HH01, Chung cư New Horizon City, 87 Lĩnh Nam,
            Phường Lĩnh Nam, Quận Hoàng Mai, Thành Phố Hà Nội.{" "}
          </span>
        </p>
        <p className="mb-2">
          Địa chỉ kho:{" "}
          <span>186 Sài Đồng, Quận Long Biên, Thành Phố Hà Nội.</span>
        </p>
        <p className="mb-2">
          Điện thoại: <span> 1900.6536</span>
        </p>

        <br />

        <blockquote className="mb-3">
          <p>5. Sử dụng Cookie</p>
        </blockquote>
        <p>
          Cookie là tập tin văn bản nhỏ có thể nhận dạng tên truy cập duy nhất
          từ máy tính của bạn đến máy chủ của chúng tôi khi bạn truy cập vào các
          trang nhất định trên website và sẽ được lưu bởi trình duyệt internet
          lên ổ cứng máy tính của bạn. Cookie được dùng để nhận dạng địa chỉ IP,
          lưu lại thời gian. Chúng tôi dùng cookie để tiện cho quý khách vào web
          (ví dụ: ghi nhớ tên truy cập khi bạn muốn vào thay đổi lại giỏ mua
          hàng mà không cần phải nhập lại địa chỉ email của mình) và không đòi
          hỏi bất kỳ thông tin nào về bạn (ví dụ: mục tiêu quảng cáo). Trình
          duyệt của bạn có thể được thiết lập không sử dụng cookie nhưng điều
          này sẽ hạn chế quyền sử dụng của bạn trên web. Xin vui lòng chấp nhận
          cam kết của chúng tôi là cookie không bao gồm bất cứ chi tiết cá nhân
          riêng tư nào và an toàn với virus. Muốn biết thêm về cookie, vui lòng
          truy cập web{" "}
          <a href="http://www.allaboutcookies.org" className="text-primary">
            http://www.allaboutcookies.org
          </a>{" "}
          hoặc để tìm hiểu cách loại bỏ cookie khỏi trình duyệt, vui lòng vào{" "}
          <a
            href="http://www.allaboutcookies.org/manage-cookies/index.html."
            className="text-primary"
          >
            http://www.allaboutcookies.org/manage-cookies/index.html.
          </a>{" "}
        </p>
        <br />

        <br />

        <blockquote className="mb-3">
          <p>6. Bảo mật</p>
        </blockquote>
        <p className="mb-2">
          Giga Digital có biện pháp thích hợp về kỹ thuật và an ninh để ngăn
          chặn truy cập trái phép hoặc trái pháp luật hoặc mất mát hoặc tiêu hủy
          hoặc thiệt hại cho thông tin của bạn. Khi thu thập dữ liệu trên web,
          chúng tôi thu thập chi tiết cá nhân của bạn trên máy chủ an toàn.
          Chúng tôi duy trì các biện pháp bảo vệ vật lý và điện tử trong mối
          liên kết với thu thập, lưu trữ và tiết lộ thông tin của bạn. Các thủ
          tục an toàn của chúng tôi nghĩa là chúng tôi có thể đôi khi yêu cầu
          giấy tờ chứng minh trước khi tiết lộ thông tin cá nhân cho bạn.
        </p>
        <p className="mb-2">
          Chúng tôi khuyên quý khách rằng quý khách không nên đưa thông tin chi
          tiết về việc thanh toán với bất kỳ ai bằng e-mail, chúng tôi không
          chịu trách nhiệm về những mất mát quý khách có thể gánh chịu trong
          việc trao đổi thông tin của quý khách qua internet hoặc email.
        </p>
        <p className="mb-2">
          Quý khách tuyệt đối không sử dụng bất kỳ chương trình, công cụ hay
          hình thức nào khác để can thiệp vào hệ thống hay làm thay đổi cấu trúc
          dữ liệu. Nghiêm cấm việc phát tán, truyền bá hay cổ vũ cho bất kỳ hoạt
          động nào nhằm can thiệp, phá hoại hay xâm nhập vào dữ liệu của hệ
          thống website. Mọi vi phạm sẽ bị tước bỏ mọi quyền lợi cũng như sẽ bị
          truy tố trước pháp luật nếu cần thiết.
        </p>
        <p className="mb-2">
          Mọi thông tin giao dịch sẽ được bảo mật nhưng trong trường hợp cơ quan
          pháp luật yêu cầu, chúng tôi sẽ buộc phải cung cấp những thông tin này
          cho các cơ quan pháp luật.
        </p>
        <p className="mb-2">
          Các điều kiện, điều khoản và nội dung của trang web này được điều
          chỉnh bởi luật pháp Việt Nam và tòa án Việt Nam có thẩm quyền xem xét.
        </p>
        <br />

        <blockquote className="mb-3">
          <p>7. Quyền lợi khách hàng</p>
        </blockquote>
        <p className="">
          Quý khách có quyền yêu cầu truy cập vào dữ liệu cá nhân của mình, có
          quyền yêu cầu Giga Digital sửa lại những sai sót trong dữ liệu của bạn
          mà không mất phí. Bất cứ lúc nào bạn cũng có quyền yêu cầu chúng tôi
          ngưng sử dụng dữ liệu cá nhân của bạn cho mục đích tiếp thị.
        </p>
      </div>
    </div>
  );
};

export default chinhSachBaoMat;
